import React from 'react'
import JustRow from "../../../styleHelper/JustRow"
import List from "../../../styleHelper/List"
import Col from 'react-bootstrap/Col';
export default function FreeRow(props) {
    return (
        <JustRow className="colorBg pripary-light alignCenter freeRow"
            title="یک ماه رایگان تست کنید"
            description="اگر مطمعن نیستید میتوانید رایگان تست کنید و مطمعن شوید، این فقط یک متن تستی است">
            <Col>
                <List withCheck listItems={[
                    "تعداد 10 شرکت کننده",
                    "تعداد 3 ویدئو همزمان",
                    "مدت زمان 1 ماه استفاده"
                ]} />
                <div className="btns">
                    <a href="/" className="btn btn-primary">تست رایگان</a>
                </div>
            </Col>
        </JustRow>
    )
}